import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import _ from 'underscore';

import FILING_CONTROLLER from '../../../controllers/filing';
import MANUAL_DOCUMENTS_CONTROLLER from '../../../controllers/manualDocuments';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import GLOBAL_FILTER_CONTROLLER from '../../../controllers/globalFilter';
import Box from './Box';
import VatBoxDetails from './VATBoxDetails';
import ManualDocumentsButton from '../manualDocuments/ManualDocumentsButton';
import ManualDocumentsModal from '../manualDocuments/ManualDocumentsModal';
import ManualDocumentsForm from '../manualDocuments/ManualDocumentsForm';
import ManualDocumentsVATReturnsLineEditor from '../manualDocuments/ManualDocumentsVATReturnsLineEditor';
import ReactComponentHelper from '../../helper/ReactComponentHelper';
import {VATBookLineType, VATBoxType, ReturnPeriodTimeType, ReturnDisplayType} from '../../../utils/enums';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import {getEnumBy} from '../../helper/ReactComponentHelper';
import getClientConfig from '../../../utils/getClientConfig';
import StringFunctions from '../../../utils/stringFunctions';
import { sanitizeCsvData } from '../../../utils/csvSanitizer';
import { CSVLink } from 'react-csv';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';

const log = new Logger('VAT_RETURN_FILING_VALUES', LOG_LEVELS.DEBUG);

const MODAL_CLASSNAMES =  {
    modal: 'modal-full-width modal-max-width-65'
};
const { enableCorrections } = getClientConfig();
export class FilingValues extends Component {

  constructor(props) {
    super(props);
    this.state = {
      openManualDocumentsModal: false,
      openVatBoxDetailsModal:false,
      currentBox:{},
      showBoxDescription: 'yes'
    };
    this.handleShowBoxDescriptionChange = this.handleShowBoxDescriptionChange.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeVatBoxDetailsModal = this.closeVatBoxDetailsModal.bind(this);
    this.onManualDocumentsFormSubmit = this.onManualDocumentsFormSubmit.bind(this);
    this.fetchVATBoxesAndOpenModal = this.fetchVATBoxesAndOpenModal.bind(this);
    this.fetchFilingValueDetails = this.fetchFilingValueDetails.bind(this);
    this.fetchVATBoxDetails = this.fetchVATBoxDetails.bind(this);
    this.applyClickHandler = this.applyClickHandler.bind(this);
    this.onExportVatBoxDetailsCSVHandler = this.onExportVatBoxDetailsCSVHandler.bind(this);
    this.buildCSVData = this.buildCSVData.bind(this);
  }


  openModal() {
    this.setState({
        openManualDocumentsModal: true
     }); 
  }

  fetchVATBoxesAndOpenModal() {
    const params = {
      countryCode: this.props.countryCode,
      companyId: this.props.companyId,
      onDate: this.props.filingPeriod.fromDate,
      callback: this.openModal
    };
    this.props.doLoadVATBoxes(params);
  }

  onManualDocumentsFormSubmit(manualDocumentsData={}) {
    log.debug('onManualDocumentsFormSubmit(): ', manualDocumentsData);
    const totalTaxableBasis = Number.parseFloat(manualDocumentsData.totalTaxableBasis);
    const totalVAT = Number.parseFloat(manualDocumentsData.totalVAT);
    const vatBoxes = _.isArray(manualDocumentsData.vatBoxes) ? manualDocumentsData.vatBoxes.map( (vatBox) => {
      const boxValue = Number.parseFloat(vatBox.boxValue);
      const vatBoxTypeEnum = getEnumBy(VATBoxType, vatBox.boxType, this.props.languages) || {};
      const returnTypeEnum = getEnumBy(ReturnPeriodTimeType, vatBox.returnType, this.props.languages) || {};
      return {
        "boxName": vatBox.boxName,
        "boxType": vatBoxTypeEnum.value,
        "boxValue": Number.isNaN(boxValue) ? 0: boxValue,
        "returnType":  returnTypeEnum.value 
      };
    }) : [];
    const documentType = VATBookLineType.enumValueOf(manualDocumentsData.documentType) || {};
    const newDocumentDetails = {
      "companyCode": manualDocumentsData.companyCode,
      "country": manualDocumentsData.country,
      "transactionDate": manualDocumentsData.transactionDate,
      "invoiceDate": manualDocumentsData.invoiceDate,
      "reporterName": manualDocumentsData.reporterName,
      "referenceCode": manualDocumentsData.referenceCode,
      "currency": manualDocumentsData.currency,
      "documentType": `${documentType.value}`,
      "totalTaxableBasis": Number.isNaN(totalTaxableBasis) ? 0 : totalTaxableBasis,
      "totalVAT": Number.isNaN(totalVAT) ? 0 : totalVAT,
      "vatBoxes": vatBoxes,
      "countryMainTransaction": manualDocumentsData.country
    };
    this.props.doCreateManualDocument(newDocumentDetails, () => {
      this.closeModal();
    });
  }

  closeModal() {
    this.setState({
        openManualDocumentsModal: false
     }); 
  }

  fetchVATBoxDetails(searchCriteria={}) {
    let dataFilter = this.getReturnDisplayDataFilter(this.props.returnDisplayType);

    let searchParam = Object.assign({}, searchCriteria, {
      filingPeriod: this.props.filingPeriod || {},
      selectedCorrectionPeriod: this.props.selectedCorrectionPeriod,
      frequency: this.props.frequency,
      countryCode: this.props.countryCode,
      companyId: this.props.companyId,
      box: this.state.currentBox || ''
    }, dataFilter);

    this.props.doLoadFilingValueDetail(searchParam);
  }

  getReturnDisplayDataFilter(returnDisplayType) {
    let excludeCorrections = 0;
    let excludeRegular = 0;
    let includeFutureCorrections = 0;
    let isCorrection = 0;
    if (!enableCorrections) {
      return { excludeCorrections, excludeRegular, includeFutureCorrections, isCorrection }
    }
    switch (+returnDisplayType) {
      case ReturnDisplayType.ONLY_NON_CORRECTIONS.value:
        excludeCorrections = 1;
        break;
      case ReturnDisplayType.CORRECTIONS_IN_THIS_PERIOD.value:
        excludeRegular = 1;
        break;
      case ReturnDisplayType.SHOW_CORRECTIONS_GROUP_BY_PERIOD.value:
        excludeRegular = 1;
        isCorrection = 1;
        break;
      case ReturnDisplayType.SHOW_CORRECTIONS_GROUP_BY_PERIOD_INCLUDING_ORIGINAL_DOCUMENTS.value:
        includeFutureCorrections = 1;
        isCorrection = 1;
        break;
    }
    return { excludeCorrections, excludeRegular, includeFutureCorrections, isCorrection }
  }

  applyClickHandler(searchCriteria={}) {
    this.fetchVATBoxDetails(searchCriteria);
  }

  fetchFilingValueDetails(box){      
    this.setState({
      currentBox:box,
      openVatBoxDetailsModal:true
    });
  }
  
  onExportVatBoxDetailsCSVHandler(selection){
    let dataFilter = this.getReturnDisplayDataFilter(this.props.returnDisplayType);
    log.debug('onExportAccountSettingsData()');
    const vatBoxDetailsCsvParams = {
          boxName: this.state.currentBox.boxName,
          companyId: this.props.companyId,
          countryCode: this.props.countryCode,
          startDate: this.props.filingPeriod.fromDate,
          endDate: this.props.filingPeriod.toDate,
          correctionStartDate: this.props.selectedCorrectionPeriod?.correctionStartDate || this.props.filingPeriod.toDate, // This default has to exist due to a specific expectation by backend
          correctionEndDate: this.props.selectedCorrectionPeriod?.correctionEndDate || this.props.filingPeriod.fromDate, // This default has to exist due to a specific expectation by backend
          boxType: this.state.currentBox.boxType,
          boxTimeType: this.state.currentBox.returnFrequency,
          isCorrection: dataFilter.isCorrection,
          checkClearance: 0,
          excludeCorrections: dataFilter.excludeCorrections,
          excludeRegular: dataFilter.excludeRegular,
          includeFutureCorrections: dataFilter.includeFutureCorrections,         
          invoiceNumber:selection.invoiceNumber,
          vatCode:selection.vatCode
    };

    return new Promise((resolve, reject)=>{
      this.props.doExportVatBoxDetailsCSV(vatBoxDetailsCsvParams,(err, data)=>{
        if(err){
          reject(err);
          return;
        }
        const downloadData = {
          content: data || '', ext: 'csv'
        };
        resolve(downloadData);
      });
    });
  };

  handleShowBoxDescriptionChange(event) {
    this.setState({ showBoxDescription: event.target.value });
  }

  closeVatBoxDetailsModal(){
    this.props.doHideVatBoxDetail();
    this.setState({
      currentBox:{},
      openVatBoxDetailsModal:false
    });
  }

  buildCSVData(taxableBasisBoxes, vatBoxes, boxDescriptionMap = {}) {
    const includeDescriptions = Object.keys(boxDescriptionMap).length > 0;

    const headers = includeDescriptions
      ? [
          ["Taxable Basis", "", "", "VAT", "", ""],
          ["Box Number", "Description", "Total Amount", "Box Number", "Description", "Total Amount"]
        ]
      : [
          ["Taxable Basis", "", "VAT", ""],
          ["Box Number", "Total Amount", "Box Number", "Total Amount"]
        ];

    const maxLength = Math.max(taxableBasisBoxes.length, vatBoxes.length);
    const dataRows = Array.from({ length: maxLength }, (_, index) => {
      const basis = taxableBasisBoxes[index] || {};
      const vat = vatBoxes[index] || {};

      if (!includeDescriptions) {
        return [
          basis?.boxName,
          basis?.boxValue,
          vat?.boxName,
          vat?.boxValue
        ];
      }

      return [
        basis?.boxName,
        this.getBoxDescription(boxDescriptionMap, basis?.boxName, 'TAXABLE_BASE') || '',
        basis?.boxValue,
        vat?.boxName,
        this.getBoxDescription(boxDescriptionMap, vat?.boxName, 'VAT') || '',
        vat?.boxValue
      ];
    });

    return [...headers, ...dataRows];
  }
  
  getBoxDescriptionMap() {
    const descriptions = this.props.boxDescriptions;
    if (!Array.isArray(descriptions)) {
      return {};
    }
    return descriptions.reduce((map, item) => {
      if (item && item.name) {
        const key = `${StringFunctions.normalizeBoxIdentifier(item.name)}|${item.boxTransactionType || ''}`;
        map[key] = item.boxDescription || '';
      }
      return map;
    }, {});
  }

  getBoxDescription(boxDescriptionMap, boxName, boxTransactionType) {
    const key = `${StringFunctions.normalizeBoxIdentifier(boxName)}|${boxTransactionType}`;
    return boxDescriptionMap[key] || undefined;
  }

  render() {
    log.debug('render(): ', this.props);
    const allAvailableVATBoxes = this.props.allAvailableVATBoxes || [];
    const allBoxes = this.props.filingValues.boxes || [];
    log.debug('render(): allBoxes: ', allBoxes);
    const taxableBasisBoxes = allBoxes.filter((box) => {
      return box.boxType === 0;
    });
    
    const vatBoxes = allBoxes.filter((box) => {
      return box.boxType === 1;
    });
    log.debug('render(): taxableBasisBoxes', taxableBasisBoxes);
    log.debug('render(): vatBoxes', vatBoxes);

    const boxDescriptionMap = this.props.featureFlags?.EnableBoxDescription
      ? this.getBoxDescriptionMap()
      : {};
    // For CSV export, only include descriptions when both flags are enabled
    const csvBoxDescriptionMap = this.props.featureFlags?.EnableBoxDescription && this.props.featureFlags?.EnableInlineBoxDescription
      ? boxDescriptionMap
      : {};
    // Enable inline descriptions for any country/frequency that actually has box descriptions available
    const hasBoxDescriptions = Object.keys(boxDescriptionMap).length > 0;
    const inlineBoxDescriptionFlagEnabled = Boolean(this.props.featureFlags?.EnableInlineBoxDescription) && hasBoxDescriptions;
    const enableInlineDescription = inlineBoxDescriptionFlagEnabled && this.state.showBoxDescription === 'yes';

    const currencyData = ReactComponentHelper.getCurrencyByCountryCode(this.props.countryCode) || {};
    const manualDocumentsButtonDisabled = !this.props.frequency;
    let companyCode;
    const matchedCompany = ReactComponentHelper.findCompanyBy('id', this.props.companyId, this.props.companyList);
    if(_.isEmpty(matchedCompany)) {
      const globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll() || {};
      companyCode = globalFilterSelection.companyCode
    } else {
      companyCode = matchedCompany.code
    }

    return (
      <div data-testid="component-vat-return-filing-values">
        {inlineBoxDescriptionFlagEnabled && (
          <div
            className="show-box-description-toggle mb15"
            data-test="show-box-description-toggle"
            data-testid="show-box-description-toggle"
          >
            <label htmlFor="show-box-description-select" className="mr10">
              Show Box Description
            </label>
            <select
              id="show-box-description-select"
              data-test="show-box-description-select"
              data-testid="show-box-description-select"
              value={this.state.showBoxDescription}
              onChange={this.handleShowBoxDescriptionChange}
            >
              <option value="no">No</option>
              <option value="yes">Yes</option>
            </select>
          </div>
        )}
        <s-row>
          <s-col span="6" data-testid="div-taxable-basis-filing-values">
            <h3 className="mb5">{LANGUAGES_CONTROLLER.format(this.props.languages, 'filingVatReturn_TaxableBasis')}</h3>
            <table className="card-table">
              <thead>
              <tr>
                <th>{LANGUAGES_CONTROLLER.format(this.props.languages, 'filingVatReturn_BoxNumber')}</th>
                <th className="text-align-right">{LANGUAGES_CONTROLLER.format(this.props.languages, 'filingVatReturn_TotalAmount')}</th>
              </tr>
              </thead>
              <tbody>
              {
                (()=> {
                  if (taxableBasisBoxes.length <= 0) {
                    return (<tr><td colSpan={3}>No values</td></tr>)
                  }
                  return taxableBasisBoxes.map((box, index) => (
                    <Box key={index}
                        countryCode={this.props.countryCode}
                        companyId={this.props.companyId}
                        filingDueDate={this.props.filingDueDate}
                        filingPeriod={this.props.filingPeriod}
                        box={box}
                        loadBoxDetail={this.fetchFilingValueDetails.bind(this, box)}
                        isEditable={this.props.isEditable}
                        boxAsLink={this.props.boxAsLink}  
                        onBoxValueChange={this.props.onBoxValueChange}
                        enableInlineDescription={enableInlineDescription}
                        boxDescription={this.getBoxDescription(boxDescriptionMap, box.boxName, 'TAXABLE_BASE')}
                    />
                  ))
                })()
              }
              </tbody>
            </table>
          </s-col>
          <s-col span="6" data-testid="div-vat-filing-values">
            <h3 className="mb5">{LANGUAGES_CONTROLLER.format(this.props.languages, 'filingVatReturn_VAT')}</h3>
            <table className="card-table">
              <thead>
              <tr>
                <th>{LANGUAGES_CONTROLLER.format(this.props.languages, 'filingVatReturn_BoxNumber')}</th>
                <th className="text-align-right">{LANGUAGES_CONTROLLER.format(this.props.languages, 'filingVatReturn_TotalAmount')}</th>
              </tr>
              </thead>
              <tbody>
              {
                (()=> {
                  if (vatBoxes.length <= 0) {
                    return (<tr><td colSpan={3}>No values</td></tr>)
                  }
                  return vatBoxes.map((box, index) => (
                    <Box key={index}
                        countryCode={this.props.countryCode}
                        companyId={this.props.companyId}
                        filingDueDate={this.props.filingDueDate}
                        filingPeriod={this.props.filingPeriod}
                        box={box}
                        loadBoxDetail={this.fetchFilingValueDetails.bind(this, box)}
                        isEditable={this.props.isEditable}
                        boxAsLink={this.props.boxAsLink}
                        onBoxValueChange={this.props.onBoxValueChange}
                        enableInlineDescription={enableInlineDescription}
                        boxDescription={this.getBoxDescription(boxDescriptionMap, box.boxName, 'VAT')}
                    />
                  ))
                })()
              }
              </tbody>
            </table>
          </s-col>
        </s-row>
        <div className='mt20'>
            <ManualDocumentsModal open={this.state.openManualDocumentsModal} onClose={this.closeModal} >
              <ManualDocumentsForm  onSubmit={this.onManualDocumentsFormSubmit} onCancel={this.closeModal} initData={{
                companyCode: companyCode,
                country: this.props.countryCode,
                currency: currencyData.currencyCode,
                reporterName: this.props.userName
              }}>
                <ManualDocumentsVATReturnsLineEditor vatBoxes={allAvailableVATBoxes} selectedCountry={this.props.countryCode} />
              </ManualDocumentsForm>
            </ManualDocumentsModal>
            {this.props.featureFlags?.EnableOpenReturnsManualDocument &&
              <ManualDocumentsButton onClick={this.fetchVATBoxesAndOpenModal} disabled={manualDocumentsButtonDisabled} />
            }
            {this.props.featureFlags?.EnableExportBoxValueOpenReturns &&
              <CSVLink
                data={sanitizeCsvData(this.buildCSVData(taxableBasisBoxes, vatBoxes, csvBoxDescriptionMap))}
                filename={'VatBoxDetails.csv'}
                className={taxableBasisBoxes.length > 0 || vatBoxes.length > 0 ? "button secondary" : "invisible"}
                role="button"
              >
                <LanguageStringResolver string='vatBoxDetails_SaveToCSV' />
              </CSVLink>
            }
        </div>
        <Modal 
          open={this.state.openVatBoxDetailsModal} 
          onClose={this.closeVatBoxDetailsModal}
          classNames={MODAL_CLASSNAMES}
        >
          <VatBoxDetails 
            boxDetails={this.props.vatBoxDetail}
            totalValue={this.state.currentBox ? this.state.currentBox.boxValue: 0.0}
            countryCode={this.props.countryCode} 
            filingPeriod={this.props.filingPeriod}
            fetchRequestHandler={this.fetchVATBoxDetails}
            onApplyClick={this.applyClickHandler}
            onExportVatBoxDetailsCSV ={this.onExportVatBoxDetailsCSVHandler}
          />
        </Modal>
      </div>
    );
  }
}


// Which props do we want to inject, given the global state?
export function mapStateToProps(state) {

  return {
    showToast: state.filing?.showToast,
    languages: state.languages,
    allAvailableVATBoxes: state.manualDocuments && state.manualDocuments.vatBoxes,
    vatBoxDetail: state.filing.filingValueDetails,
    companyList: state.companies && state.companies.data,
    userName: (state.authentication && state.authentication.data && state.authentication.data.userName) || "Unknown",
    customerId: state.authentication && state.authentication.data && state.authentication.data.customerId,
    featureFlags: state.featureFlag?.data,
    boxDescriptions: state.filing?.boxDescriptions
  };
}

function mapDispatchersToProps(dispatch) {
  return{
    doLoadFilingValueDetail: (searchCriteria={}) => {
      let filingPeriod = searchCriteria.filingPeriod || {};
      let box = searchCriteria.box || {}
      let apiParams = {
        boxName: box.boxName || '',
        companyId: searchCriteria.companyId || '',
        countryCode: searchCriteria.countryCode,
        startDate: filingPeriod.fromDate || undefined,
        endDate: filingPeriod.toDate || undefined,
        correctionStartDate: searchCriteria.selectedCorrectionPeriod?.correctionStartDate || filingPeriod.toDate || undefined, // This default has to exist due to a specific expectation by backend
        correctionEndDate: searchCriteria.selectedCorrectionPeriod?.correctionEndDate || filingPeriod.fromDate || undefined, // This default has to exist due to a specific expectation by backend
        boxType: box.boxType,
        boxTimeType: box.returnFrequency,
        isCorrection: searchCriteria.isCorrection,
        checkClearance: 0,
        excludeCorrections: searchCriteria.excludeCorrections,
        excludeRegular: searchCriteria.excludeRegular,
        includeFutureCorrections: searchCriteria.includeFutureCorrections,
        pageNumber:searchCriteria.pageNumber || 0,
        pageSize:searchCriteria.pageSize,
        invoiceNumber:searchCriteria.invoiceNumber,
        vatCode: searchCriteria.vatCode
      };
      dispatch(FILING_CONTROLLER.doLoadValueDetails(apiParams));
    },

    doExportVatBoxDetailsCSV: (params={}, callback=()=>{}) => {
      log.debug("doExportVatBoxDetailsCSV(): ")
      dispatch(FILING_CONTROLLER.doExportVatBoxDetailsCSV(params, callback));
    },

    doHideVatBoxDetail: () => {
      dispatch(FILING_CONTROLLER.doHideValueDetails());
    },

    doCreateManualDocument: (params={}, callback) => {
      log.debug('doCreateManualDocument(): ', params, callback);
      dispatch(MANUAL_DOCUMENTS_CONTROLLER.doCreateManualDocument(params, callback))
    },

    doLoadVATBoxes: (params) => {
      log.debug('doLoadVATBoxes(): params: ', params);
      dispatch(MANUAL_DOCUMENTS_CONTROLLER.doLoadVATBoxes(params));
    },
  }
  
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(FilingValues);
